<template>
  <b-button
    :href="$helper.playerFullUri(careerId, qs)"
    :size="size"
    :variant="variant"
    :block="isBlock"
  >
    <slot />
  </b-button>
</template>

<script>
  export default {
    name: 'BtToPlayerComponent',
    props: {
      player: {
        type: String,
        default: null,
      },
      size: {
        type: String,
        default: '',
      },
      variant: {
        type: String,
        default: 'primary',
      },
      careerId: {
        type: Number,
        default: 0,
      },
      isBlock: {
        type: Boolean,
        default: false,
      },
      qs: {
        type: Object,
        default: () => ({}),
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
